import getStateAbbreviation from '../hooks/getStateAbbreviation';
import constants from '../config/constants';
export const mapCustomerData = (customerData, customer_id) => {
  const sessionStorageCustomerData = sessionStorage.getItem(
    constants.SESS_STORAGE_CUSTOMER_INFO_KEY
  );
  if (sessionStorageCustomerData) {
    const parsedCustomerData = JSON.parse(sessionStorageCustomerData);
    if (parsedCustomerData.customer_id === customer_id) {
      return parsedCustomerData;
    }
  }
  if (customerData) {
    return {
      ...customerData,
      firstName: customerData.first_name ?? '',
      lastName: customerData.last_name ?? '',
      address: customerData.address_line ?? '',
      city: customerData.city ?? '',
      state: getStateAbbreviation(customerData.state) ?? '',
      zip: customerData.zip ?? '',
      country: customerData.country ?? '',
      email: customerData.email ?? '',
      socialSecurityNumber: customerData.customer_identity_number ?? '',
      phone: (customerData.phone_number ?? '').replace(/^\+1/, ''),
      annualIncome: (customerData.monthly_income
        ? customerData.monthly_income * 12
        : ''
      ).toString(),
      relationship: customerData.relationship ?? 'SELF',
    };
  }
  return {};
};
